import {LANGUAGE} from '@/common/utils/constants';


export const STEPS_FORM_SECTION_TRANSLATIONS = {
	[LANGUAGE.en.short]: {
		step_1_navigation_name: "About the client",
		step_2_navigation_name: "Client context",
		step_3_navigation_name: "Solution",
		step_4_navigation_name: "Supporting information",
		step_5_navigation_name: "Results",
		step_6_navigation_name: "Client Testimonial",
		step_7_navigation_name: "Akkodis expertise",
		step_8_navigation_name: "Akkodis team",
		step_9_navigation_name: "Project gallery",
	},
	[LANGUAGE.it.short]: {
		step_1_navigation_name: "Informazioni sul client",
		step_2_navigation_name: "Contesto del cliente",
		step_3_navigation_name: "Soluzione",
		step_4_navigation_name: "Informazioni di supporto",
		step_5_navigation_name: "Risultati",
		step_6_navigation_name: "Testimonial client",
		step_7_navigation_name: "Competenza akkodis",
		step_8_navigation_name: "Akkodis Team",
		step_9_navigation_name: "Galleria del progetto",
	},
	[LANGUAGE.de.short]: {
		step_1_navigation_name: "Über den Kunden",
		step_2_navigation_name: "Client -Kontext",
		step_3_navigation_name: "Lösung",
		step_4_navigation_name: "Unterstützende Informationen",
		step_5_navigation_name: "Ergebnisse",
		step_6_navigation_name: "Client Testimonial",
		step_7_navigation_name: "Akkodis Expertise",
		step_8_navigation_name: "Akkodis Team",
		step_9_navigation_name: "Projektgalerie",
	},
	[LANGUAGE.fr.short]: {
		step_1_navigation_name: "À propos du client",
		step_2_navigation_name: "Contexte client",
		step_3_navigation_name: "La solution",
		step_4_navigation_name: "Informations à l'appui",
		step_5_navigation_name: "Résultats",
		step_6_navigation_name: "Témoignage client",
		step_7_navigation_name: "Akkodis Expertise",
		step_8_navigation_name: "Akkodis Team",
		step_9_navigation_name: "Galerie du projet",
	},
	[LANGUAGE.ja.short]: {
		step_1_navigation_name: "クライアントについて",
		step_2_navigation_name: "クライアントコンテキスト",
		step_3_navigation_name: "解決",
		step_4_navigation_name: "サポート情報",
		step_5_navigation_name: "結果",
		step_6_navigation_name: "クライアントの証言",
		step_7_navigation_name: "akkodisの専門知識",
		step_8_navigation_name: "akkodisチーム",
		step_9_navigation_name: "プロジェクトギャラ",
	},
	[LANGUAGE.es.short]: {
		step_1_navigation_name: "Acerca del cliente",
		step_2_navigation_name: "Contexto del cliente",
		step_3_navigation_name: "Solución",
		step_4_navigation_name: "Información de apoyo",
		step_5_navigation_name: "Resultados",
		step_6_navigation_name: "Testimonio del cliente",
		step_7_navigation_name: "Expertise de Akkodis",
		step_8_navigation_name: "Equipo de Akkodis",
		step_9_navigation_name: "Galería de proyectos",
	},
};
